import React from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useAuthContext } from "contexts/AuthContext"
import useSound from "use-sound"
import { selectMenuItem } from "utils/sounds"
import { SidebarDrawerUI } from "./SidebarDrawer.ui"
import { professorRoutes } from "common/navigationRoutes"
import {
  FaUserFriends,
  FaBookOpen,
  FaChartPie,
  FaMedal,
  FaChalkboardTeacher,
  FaStethoscope,
  FaBook,
  FaPuzzlePiece,
  FaGraduationCap,
  FaIdBadge,
  FaHeadset,
  FaSlidersH,
  FaRegLifeRing,
  FaGamepad,
} from "react-icons/fa"
import LogoutIcon from "@mui/icons-material/Logout"

const menuItems = [
  { label: "feed", icon: <FaBookOpen />, path: professorRoutes.PROFESSOR_FEED },
  {
    label: "Classes",
    icon: <FaUserFriends />,
    path: professorRoutes.PROFESSOR_GROUPS,
  },
  {
    label: "students",
    icon: <FaUserFriends />,
    path: professorRoutes.PROFESSOR_STUDENTS,
  },
  { label: "rewards", icon: <FaMedal />, path: "" },
  {
    label: "Missions",
    icon: <FaBookOpen />,
    path: professorRoutes.PROFESSOR_MISSIONS,
  },
  { label: "content", icon: <FaBook />, path: professorRoutes.CONTENT },
  { label: "games", icon: <FaGamepad />, path: professorRoutes.GAMES },
  {
    label: "Grades",
    icon: <FaChartPie />,
    path: professorRoutes.PROFESSOR_GRADES,
  },
  { label: "activities_to_grade", icon: <FaChalkboardTeacher />, path: "" },
  { label: "diagnostic_test", icon: <FaStethoscope />, path: "" },
  { label: "Customize_your_curriculum", icon: <FaPuzzlePiece />, path: "" },
  { label: "Training", icon: <FaGraduationCap />, path: "" },
  { label: "Licenses", icon: <FaIdBadge />, path: "" },
  { label: "" },
  { label: "Technical Support", icon: <FaHeadset />, path: "" },
  {
    label: "Settings",
    icon: <FaSlidersH />,
    path: professorRoutes.PROFESSOR_ACCOUNT,
  },
  { label: "Tutorials", icon: <FaRegLifeRing />, path: "" },
  { label: "" },
  { label: "Logout", icon: <LogoutIcon />, path: "" },
]

export const ProfessorSidebarView = ({ open = false, onClose = () => {} }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const {
    userData,
    updateUserData,
    logout,
    audioSettings,
    isConfigurationCompleted,
  } = useAuthContext()
  const [playMenuItem] = useSound(selectMenuItem, {
    volume: 0.5,
    html5: false,
  })

  const visibleMenuItems = menuItems.filter((item, index) => {
    if (!isConfigurationCompleted && index <= 12) {
      return false
    }
    return true
  })

  const onMenuItemClick = (path) => {
    if (audioSettings?.enabledAudioEffects) {
      playMenuItem()
    }
    navigate(path)
    onClose()
  }

  const changeTutorialsPreference = (evt) => {
    evt.stopPropagation()
    updateUserData({
      newUserData: {
        allowTutorials: !userData?.allowTutorials,
      },
    })
  }

  const openExternalLink = (url) => {
    if (audioSettings?.enabledAudioEffects) {
      playMenuItem()
    }
    onClose()
    window.open(url, "_blank", "noopener,noreferrer")
  }

  return (
    <SidebarDrawerUI
      open={open}
      onClose={onClose}
      menuItems={visibleMenuItems}
      userData={userData}
      onMenuItemClick={onMenuItemClick}
      onLogout={() => {
        onClose()
        logout()
      }}
      onChangeTutorialsPreference={changeTutorialsPreference}
      onOpenExternalLink={openExternalLink}
      currentRoute={location.pathname}
    />
  )
}
